export default {
    getNeoOpcionesMapear(state, getters, rootState){
        let ops = state.productosNeoOpciones;
        let prd = rootState.productos.productoEditando;
        let prdsNeoAll = state.productosNeo;
        let prdNeo = ops.find((e) => e.Articulo == prd.mapeoNeo)
        let res = [];
        if (prdNeo){
            console.log(prdNeo);
            let opciones = [];
            prdNeo.Elementos.forEach(el => {
                opciones = opciones.concat(el.Opciones)
            });
            opciones.forEach(o => {
                let found = prdsNeoAll.find((e) => e.Codigo == o.Componente)
                let nombre = (found) ? found.Nombre : 'No encontrado'
                let aux = {
                    codigo : o.Componente,
                    precio : o.Precio,
                    nombre : nombre
                }
                res.push(aux);
            });
        }
        return res;
    }
}